// // What stages you are in (2 section)

// import React, { useState, useRef } from 'react';
// import data from '../../femcare-content.json';

// const { stages } = data.sections;

// const WhatStages = () => {
//   const { id, heading, items } = stages;

//   const [startIndex, setStartIndex] = useState(0);
//   const touchStartX = useRef(0);
//   const touchEndX = useRef(0);

//   const getVisibleCount = () => {
//     if (typeof window === 'undefined') return 4;
//     if (window.innerWidth < 640) return 1;     // mobile
//     if (window.innerWidth < 1024) return 2;    // tablet
//     return 4;                                  // desktop
//   };

//   const [visibleCount, setVisibleCount] = useState(getVisibleCount());

//   React.useEffect(() => {
//     const handleResize = () => {
//       setVisibleCount(getVisibleCount());
//       setStartIndex(0);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const maxStart = Math.max(0, items.length - visibleCount);
//   const canPrev = startIndex > 0;
//   const canNext = startIndex < maxStart;

//   const handlePrev = () => {
//     if (canPrev) setStartIndex((prev) => prev - 1);
//   };

//   const handleNext = () => {
//     if (canNext) setStartIndex((prev) => prev + 1);
//   };

//   /* Swipe Handlers */
//   const onTouchStart = (e) => {
//     touchStartX.current = e.targetTouches[0].clientX;
//   };

//   const onTouchMove = (e) => {
//     touchEndX.current = e.targetTouches[0].clientX;
//   };

//   const onTouchEnd = () => {
//     const distance = touchStartX.current - touchEndX.current;

//     if (distance > 50 && canNext) {
//       handleNext(); // swipe left
//     } else if (distance < -50 && canPrev) {
//       handlePrev(); // swipe right
//     }
//   };

//   // return (
//   //   <section id={id} className="w-full py-6 md:py-8" 
//   //   style={{ backgroundColor: 'var(--gray-100)' }}
//   //   >
//   //     <div className="container mx-auto px-4 md:px-8">

//   //       <div
//   //         className="w-full rounded-2xl bg-white px-6 md:px-8 py-6 md:py-8"
//   //         style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}
//   //       >

//   //         {/* Header */}
//   //         <div className="flex items-end justify-between mb-6">
//   //           <div>
//   //             <h2
//   //               className="ava-heading-lg "
//   //               // style={{ color: 'var(--primary-color)' }}
//   //             >
//   //               {heading}
//   //             </h2>
//   //             {/* <div
//   //               className="mt-1.5 rounded-full"
//   //               style={{
//   //                 height: '3px',
//   //                 width: '100%',
//   //                 backgroundColor: 'var(--primary-color)',
//   //               }}
//   //             /> */}
//   //           </div>

//   //           {/* Arrows */}
//   //           {items.length > visibleCount && (
//   //             <div className="flex items-center gap-2 ml-4">
//   //               <ArrowBtn direction="left" onClick={handlePrev} disabled={!canPrev} />
//   //               <ArrowBtn direction="right" onClick={handleNext} disabled={!canNext} />
//   //             </div>
//   //           )}
//   //         </div>

//   //         {/* Swipe + Sliding Container */}
//   //         <div
//   //           className="overflow-hidden"
//   //           onTouchStart={onTouchStart}
//   //           onTouchMove={onTouchMove}
//   //           onTouchEnd={onTouchEnd}
//   //         >
//   //           <div
//   //             className="flex transition-transform duration-300"
//   //             style={{
//   //               transform: `translateX(-${(100 / visibleCount) * startIndex}%)`,
//   //             }}
//   //           >
//   //             {items.map((item) => (
//   //               <div
//   //                 key={item.id}
//   //                 style={{
//   //                   flex: `0 0 ${100 / visibleCount}%`,
//   //                   padding: '0 6px',
//   //                 }}
//   //               >
//   //                 <SymptomCard item={item} />
//   //               </div>
//   //             ))}
//   //           </div>
//   //         </div>

//   //       </div>
//   //     </div>
//   //   </section>
//   // );

//   return (
//     <section id={id} className="w-full ava-section-gap"
//       style={{ backgroundColor: 'var(--gray-100)' }}
//     >
//       <div className="container mx-auto px-4 md:px-8">
//         <div
//           className="w-full ava-radius-md bg-white px-6 md:px-8 py-6 md:py-8"
//           style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}
//         >

//           {/* Header — no arrows here anymore */}
//           <div className="flex items-end justify-between ava-heading-gap">
//             <h2 className="ava-heading-lg">{heading}</h2>
//           </div>

//           {/* Slider wrapper — position relative so arrows can overlay */}
//           <div className="relative">

//             {/* Left Arrow — on the image, left edge */}
//             {/* {canPrev && ( */}
//             <div
//               className="absolute z-10"
//               style={{
//                 left: '-15px',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//                 aspectRatio: '4/3', // keeps it centered in the image height zone
//                 display: 'flex',
//                 alignItems: 'center',
//               }}
//             >
//               <ArrowBtn direction="left" onClick={handlePrev}
//                 disabled={!canPrev}
//               />
//             </div>
//             {/* )} */}

//             {/* Right Arrow — on the image, right edge */}
//             {/* {canNext && ( */}
//             <div
//               className="absolute z-10"
//               style={{
//                 right: '-15px',
//                 top: '50%',
//                 transform: 'translateY(-50%)',
//                 display: 'flex',
//                 alignItems: 'center',
//               }}
//             >
//               <ArrowBtn direction="right" onClick={handleNext} disabled={!canNext} />
//             </div>
//             {/* )} */}

//             {/* Sliding track */}
//             <div
//               className="overflow-hidden"
//               onTouchStart={onTouchStart}
//               onTouchMove={onTouchMove}
//               onTouchEnd={onTouchEnd}
//             >
//               <div
//                 className="flex ava-card-gap  transition-transform duration-300"
//                 style={{
//                   transform: `translateX(-${(100 / visibleCount) * startIndex}%)`,
//                 }}
//               >
//                 {items.map((item) => (
//                   <div
//                     key={item.id}
//                     style={{
//                       // flex: `0 0 ${100 / visibleCount}%`,
//                       flex: `0 0 calc(
//                     (100% - ((${visibleCount} - 1) * var(--ava-card-gap)))
//                     / ${visibleCount}
//                   )`,
//                       // padding: '0 6px',
//                     }}
//                   >
//                     <SymptomCard item={item} />
//                   </div>
//                 ))}
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//     </section>
//   );
//   // };
// };

// /* Arrow */
// // const ArrowBtn = ({ direction, onClick, disabled }) => (
// //   <button
// //     onClick={onClick}
// //     disabled={disabled}
// //     className={`w-10 h-10 flex items-center justify-center rounded-full bg-white border ${disabled ? 'ava-arrow-disabled' : 'ava-arrow-active'}`}

// //     style={{ cursor: disabled ? 'not-allowed' : 'pointer', borderColor: disabled ? 'var(--gray-300)' : 'var(--primary-color)', opacity: disabled ? 0.4 : 1 }}
// //   >
// //     <img
// //       src={direction === 'left' ? '/images/left-arrow.svg' : '/images/right-arrow.svg'}
// //       alt={direction}
// //       className="w-10 h-10"
// //     />
// //   </button>
// // );

// const ArrowBtn = ({ direction, onClick, disabled }) => (
//   <button
//     onClick={onClick}
//     disabled={disabled}
//     aria-label={direction === 'left' ? 'Previous' : 'Next'}
//     className="w-10 h-10 flex items-center justify-center rounded-full bg-white border transition-all duration-200"
//     style={{
//       cursor: disabled ? 'not-allowed' : 'pointer',
//       borderColor: disabled
//         ? 'var(--gray-300)'
//         : 'var(--primary-color)',
//       opacity: disabled ? 0.4 : 1,
//       boxShadow: disabled
//         ? 'none'
//         : '0 2px 10px rgba(0,36,107,0.12)',
//     }}
//   >
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke={
//         disabled
//           ? '#9ca3af'
//           : 'var(--primary-color)'
//       }
//       strokeWidth="2.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       {direction === 'left' ? (
//         <polyline points="15 18 9 12 15 6" />
//       ) : (
//         <polyline points="9 18 15 12 9 6" />
//       )}
//     </svg>
//   </button>
// );

// /* Card */
// const SymptomCard = ({ item }) => {
//   return (
//     <div
//       // href={item.href || '#'}
//       className="relative block ava-radius-md ava-card-image overflow-hidden group "
//       style={{ aspectRatio: '4/3' }}
//     >
//       <img
//         src={item.image}
//         alt={item.label}
//         className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 "
//       />

//       <div
//         className="absolute inset-0"
//         style={{
//           background: 'linear-gradient(to bottom, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.28) 100%)',
//         }}
//       />

//       {/* Reduced font for mobile & tablet */}
//       <div
//         className="absolute top-3 left-3 ava-radius-md px-2 py-1 text-black ava-text-body"
//         style={{
//           backgroundColor: 'var(--secondary-color)',
//           // fontSize: 'clamp(0.65rem, 1.2vw, 0.85rem)',
//         }}
//       >
//         {item.label}
//       </div>
//     </div>
//   );
// };

// export default WhatStages;






// // import React, { useState } from 'react';
// // import data from '../../femcare-content.json';

// // const { stages } = data.sections;

// // const VISIBLE_COUNT = 4;

// // const WhatStages = () => {
// //   const { id, heading, seeAllHref, items } = stages;
// //   const [showAll, setShowAll] = useState(false);

// //   const hasMore = items.length > VISIBLE_COUNT;
// //   const visibleItems = showAll ? items : items.slice(0, VISIBLE_COUNT);

// //   return (
// //     <section id={id} className="w-full py-6 md:py-8" style={{ backgroundColor: 'var(--gray-100)' }}>
// //       <div className="container mx-auto px-4 md:px-8">

// //         {/* Card wrapper */}
// //         <div
// //           className="w-full rounded-2xl bg-white px-6 md:px-8 py-6 md:py-8"
// //           style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}
// //         >

// //           {/* ── Header row ── */}
// //           <div className="flex items-end justify-between mb-6">
// //             {/* Heading with primary-coloured underline */}
// //             <div>
// //               <h2
// //                 className="font-semibold text-base md:text-lg lg:text-xl leading-snug"
// //                 style={{ color: 'var(--primary-color)' }}
// //               >
// //                 {heading}
// //               </h2>
// //               <div
// //                 className="mt-1.5 rounded-full"
// //                 style={{
// //                   height: '3px',
// //                   width: '100%',
// //                   backgroundColor: 'var(--primary-color)',
// //                 }}
// //               />
// //             </div>

// //             {/* See All — only when more than 4 items */}
// //             {/* {hasMore && (
// //               <button
// //                 onClick={() => setShowAll((prev) => !prev)}
// //                 className="text-sm font-medium flex-shrink-0 ml-4 transition-colors duration-200 hover:underline"
// //                 style={{ color: 'var(--primary-color)' }}
// //               >
// //                 {showAll ? 'See Less' : 'See All'}
// //               </button>
// //             )} */}
// //           </div>

// //           {/* ── Cards Grid ── */}
// //           <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
// //             {visibleItems.map((item) => (
// //               <SymptomCard key={item.id} item={item} />
// //             ))}
// //           </div>

// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // /* ── Individual Symptom Card ── */
// // const SymptomCard = ({ item }) => {
// //   return (
// //     <a
// //       href={item.href || '#'}
// //       className="relative block rounded-xl overflow-hidden group cursor-pointer"
// //       style={{ aspectRatio: '4/3' }}
// //       aria-label={item.label}
// //     >
// //       {/* Background image */}
// //       <img
// //         src={item.image}
// //         alt={item.label}
// //         className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
// //         draggable={false}
// //       />

// //       {/* Subtle dark gradient at bottom for depth */}
// //       <div
// //         className="absolute inset-0"
// //         style={{
// //           background: 'linear-gradient(to bottom, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.28) 100%)',
// //         }}
// //       />

// //       {/* Label badge — top left */}
// //       <div
// //         className="absolute top-3 left-3 rounded-md px-2.5 py-1.5 text-white text-xs md:text-sm font-medium leading-tight"
// //         style={{
// //           backgroundColor: 'var(--primary-color)',
// //           maxWidth: 'calc(100% - 1.5rem)',
// //         }}
// //       >
// //         {item.label}
// //       </div>
// //     </a>
// //   );
// // };

// // export default WhatStages;

// What stages you are in (2 section)

import React, { useState, useRef } from 'react';
import data from '../../femcare-content.json';
import { useNavigate } from 'react-router-dom';
import TalkToCareGuideButton from '../whatsapp/whatsappIntegration';

const { stages } = data.sections;

const WhatStages = () => {
  const { id, heading, items } = stages;
const navigate=useNavigate()

  const [startIndex, setStartIndex] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const getVisibleCount = () => {
    if (typeof window === 'undefined') return 4;
    if (window.innerWidth < 640) return 1;     // mobile
    if (window.innerWidth < 1024) return 2;    // tablet
    return 4;                                  // desktop
  };

  const [visibleCount, setVisibleCount] = useState(getVisibleCount());

  React.useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount());
      setStartIndex(0);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const maxStart = Math.max(0, items.length - visibleCount);
  const canPrev = startIndex > 0;
  const canNext = startIndex < maxStart;

  const handlePrev = () => {
    if (canPrev) setStartIndex((prev) => prev - 1);
  };

  const handleNext = () => {
    if (canNext) setStartIndex((prev) => prev + 1);
  };

  /* Swipe Handlers */
  const onTouchStart = (e) => {
    touchStartX.current = e.targetTouches[0].clientX;
  };

  const onTouchMove = (e) => {
    touchEndX.current = e.targetTouches[0].clientX;
  };

  const onTouchEnd = () => {
    const distance = touchStartX.current - touchEndX.current;

    if (distance > 50 && canNext) {
      handleNext(); // swipe left
    } else if (distance < -50 && canPrev) {
      handlePrev(); // swipe right
    }
  };

  // return (
  //   <section id={id} className="w-full py-6 md:py-8" 
  //   style={{ backgroundColor: 'var(--gray-100)' }}
  //   >
  //     <div className="container mx-auto px-4 md:px-8">

  //       <div
  //         className="w-full rounded-2xl bg-white px-6 md:px-8 py-6 md:py-8"
  //         style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}
  //       >

  //         {/* Header */}
  //         <div className="flex items-end justify-between mb-6">
  //           <div>
  //             <h2
  //               className="ava-heading-lg "
  //               // style={{ color: 'var(--primary-color)' }}
  //             >
  //               {heading}
  //             </h2>
  //             {/* <div
  //               className="mt-1.5 rounded-full"
  //               style={{
  //                 height: '3px',
  //                 width: '100%',
  //                 backgroundColor: 'var(--primary-color)',
  //               }}
  //             /> */}
  //           </div>

  //           {/* Arrows */}
  //           {items.length > visibleCount && (
  //             <div className="flex items-center gap-2 ml-4">
  //               <ArrowBtn direction="left" onClick={handlePrev} disabled={!canPrev} />
  //               <ArrowBtn direction="right" onClick={handleNext} disabled={!canNext} />
  //             </div>
  //           )}
  //         </div>

  //         {/* Swipe + Sliding Container */}
  //         <div
  //           className="overflow-hidden"
  //           onTouchStart={onTouchStart}
  //           onTouchMove={onTouchMove}
  //           onTouchEnd={onTouchEnd}
  //         >
  //           <div
  //             className="flex transition-transform duration-300"
  //             style={{
  //               transform: `translateX(-${(100 / visibleCount) * startIndex}%)`,
  //             }}
  //           >
  //             {items.map((item) => (
  //               <div
  //                 key={item.id}
  //                 style={{
  //                   flex: `0 0 ${100 / visibleCount}%`,
  //                   padding: '0 6px',
  //                 }}
  //               >
  //                 <SymptomCard item={item} />
  //               </div>
  //             ))}
  //           </div>
  //         </div>

  //       </div>
  //     </div>
  //   </section>
  // );

  return (
    <section id={id} className="w-full py-6 md:py-8"
      style={{ backgroundColor: 'var(--gray-100)' }}
    >
      <div className="container mx-auto px-4 md:px-8">
        <div
          className="w-full ava-radius-md bg-white px-6 md:px-8 py-6 md:py-8"
          style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}
        >

          {/* Header — no arrows here anymore */}
          <div className="flex items-end justify-between mb-6">
            <h2 className="ava-heading-lg">{heading}</h2>
          </div>

          {/* Slider wrapper — position relative so arrows can overlay */}
          <div className="relative">

            {/* Left Arrow — on the image, left edge */}
            {/* {canPrev && ( */}
            <div
              className="absolute z-10"
              style={{
                left: '-15px',
                top: '50%',
                transform: 'translateY(-50%)',
                aspectRatio: '4/3', // keeps it centered in the image height zone
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {/* <ArrowBtn direction="left" onClick={handlePrev}
                disabled={!canPrev}
              /> */}
            </div>
            {/* )} */}

            {/* Right Arrow — on the image, right edge */}
            {/* {canNext && ( */}
            <div
              className="absolute z-10"
              style={{
                right: '-15px',
                top: '50%',
                transform: 'translateY(-50%)',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {/* <ArrowBtn direction="right" onClick={handleNext} disabled={!canNext} /> */}
            </div>
            {/* )} */}

            {/* Sliding track */}
            <div
              className="overflow-hidden"
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
            >
              <div
                className="flex ava-card-gap transition-transform duration-300"
                style={{
                  transform: `translateX(-${(100 / visibleCount) * startIndex}%)`,
                }}
              >
                {items.map((item) => (
                  <div
                    key={item.id}
                    //   style={{

                    //     flex: `0 0 calc(
                    //   (100% - ((${visibleCount} - 1) * var(--ava-card-gap)))
                    //   / ${visibleCount}
                    // )`,

                    //   }}
                    style={{
                      flex: "0 0 18%",
                    }}
                  >
                    <SymptomCard item={item} />
                  </div>
                ))}
              </div>
            </div>

          </div>

           <p className='ava-text-subheading text-center mt-5'>Get personalized guidance for your health concerns.</p>
           <div className='flex items-center justify-center mt-5 gap-3'>
            {/* <button className='btn-transparent' onClick={()=>navigate('/health-assessment')}>
              Talk to Care Guide
            </button> */}
            <TalkToCareGuideButton className='btn-transparent'/>
            <button className='btn-primary' onClick={()=>navigate('/health-assessment')}>
              Take Assessment
            </button>
           </div>
        </div>
      </div>
     
    </section>
  );
  // };
};

/* Arrow */
const ArrowBtn = ({ direction, onClick, disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`w-10 h-10 flex items-center justify-center rounded-full bg-white border ${disabled ? 'ava-arrow-disabled' : 'ava-arrow-active'}`}

    style={{ cursor: disabled ? 'not-allowed' : 'pointer', borderColor: disabled ? 'var(--gray-300)' : 'var(--primary-color)', opacity: disabled ? 0.4 : 1 }}
  >
    <img
      src={direction === 'left' ? '/images/left-arrow.svg' : '/images/right-arrow.svg'}
      alt={direction}
      className="w-10 h-10"
    />
  </button>
);

/* Card */
const SymptomCard = ({ item }) => {
  return (
    <div
      // href={item.href || '#'}
      className="relative block ava-radius-md overflow-hidden group ava-card-image"
      style={{ aspectRatio: '4/3' }}
    >
      <img
        src={item.image}
        alt={item.label}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 "
      />

      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.08) 0%, rgba(0,0,0,0.28) 100%)',
        }}
      />

      {/* Reduced font for mobile & tablet */}
      <div
        className="absolute top-3 left-3 ava-radius-md px-2 py-1 text-black  ava-text-body"
        style={{
          backgroundColor: 'var(--secondary-color)',
          // fontSize: 'clamp(0.65rem, 1.2vw, 0.85rem)',
        }}
      >
        {item.label}
      </div>
    </div>
  );
};

export default WhatStages;


